import React, { useState } from "react";
import { BASE_URL_FOODS } from "../../../services/config";

interface CouponFormProps {
  userId?: number;
  category: "meals" | "nutrition";
  onApplyDiscount: (discount: number, type: string, code: string) => void;
}

const CouponForm: React.FC<CouponFormProps> = ({ userId, category, onApplyDiscount }) => {
  const [code, setCode] = useState("");
  const [message, setMessage] = useState("");
  const [discount, setDiscount] = useState<number | null>(null);
  const [isApplied, setIsApplied] = useState(false);

  const validateCoupon = async () => {
    try {
      const response = await fetch(BASE_URL_FOODS + "/v1/coupon/validate", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          code: code.toUpperCase(),
          userId: userId ?? null, // 🔹 Si userId es undefined, enviamos null
          category,
        }), 
      });
  
      const data = await response.json();
  
      if (!response.ok) {
        throw new Error(data.message || "Error al validar el cupón.");
      }
  
      setDiscount(data.discount);
      setMessage("✅ Cupón válido: Descuento aplicado.");
      onApplyDiscount(data.discount, data.type, code);
      setIsApplied(true);
    } catch (error) {
      if (error instanceof Error) {
        setMessage(error.message || "❌ Error al validar el cupón.");
      } else {
        setMessage("❌ Error desconocido.");
      }
      setDiscount(null);
      setIsApplied(false);
    }
  };
  
  

  return (
    <div className="coupon-container">
      Aplicar cupón
      <div>
      <input
        type="text"
        placeholder="Código del cupón"
        value={code}
        onChange={(e) => setCode(e.target.value.toUpperCase())}
        disabled={isApplied}
      />
      <button onClick={validateCoupon} disabled={isApplied}>Validar Cupón</button>

      </div>
      
      {message && <p>{message}</p>}
      {discount !== null && <p>Descuento aplicado: {discount}</p>}
    </div>
  );
};

export default CouponForm;
